import { render } from "./MarketPlaceMedicationStories.vue?vue&type=template&id=088f4d7e&lang=html"
import script from "./MarketPlaceMedicationStories.vue?vue&type=script&lang=js"
export * from "./MarketPlaceMedicationStories.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__